import { App as CapacitorApp } from '@capacitor/app';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Binds the Android hardware/swipe back button to React Router navigation.
 * If no navigation history exists, exits the app.
 */
export function useCapacitorBackButtonHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    let listener;

    const setupListener = async () => {
      listener = await CapacitorApp.addListener('backButton', () => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          CapacitorApp.exitApp();
        }
      });
    };

    setupListener();

    return () => {
      if (listener && typeof listener.remove === 'function') {
        listener.remove();
      }
    };
  }, [navigate]);
}
